export default {
    list: [],
    isFetching: false,
    error: null
};
